import NewWayOfClamingMobile from "./mobile/NewWayOfClamingMobile";
import NewWayOfClaimingDesktop from "./desktop/NewWayOfClaimingDesktop";

export { NewWayOfClamingMobile, NewWayOfClaimingDesktop };
